const cuisinesList: string[] = [
  'African',
  'American',
  'Asian',
  'British',
  'Caribbean',
  'Chinese',
  'Cuban',
  'European',
  'French',
  'German',
  'Greek',
  'Indian',
  'Indonesian',
  'Iranian',
  'Irish',
  'Italian',
  'Japanese',
  'Jamaican',
  'Korean',
  'Lebanese',
  'Malaysian',
  'Mediterranean',
  'Mexican',
  'Middle Eastern',
  'Polish',
  'Philippine',
  'Puerto Rican',
  'Russian',
  'Singaporean',
  'Scandinavian',
  'South American',
  'Spanish',
  'Syrian',
  'Thai',
  'Vietnamese',
]

export const cuisinesListOptions: { label: string; value: string }[] = [
  { value: '', label: '-' },
  { value: 'African', label: 'African' },
  { value: 'American', label: 'American' },
  { value: 'Asian', label: 'Asian' },
  { value: 'British', label: 'British' },
  { value: 'Caribbean', label: 'Caribbean' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Cuban', label: 'Cuban' },
  { value: 'European', label: 'European' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Indian', label: 'Indian' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Iranian', label: 'Iranian' },
  { value: 'Irish', label: 'Irish' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Jamaican', label: 'Jamaican' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Lebanese', label: 'Lebanese' },
  { value: 'Malaysian', label: 'Malaysian' },
  { value: 'Mediterranean', label: 'Mediterranean' },
  { value: 'Mexican', label: 'Mexican' },
  { value: 'Middle Eastern', label: 'Middle Eastern' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Philippine', label: 'Philippine' },
  { value: 'Puerto Rican', label: 'Puerto Rican' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Singaporean', label: 'Singaporean' },
  { value: 'Scandinavian', label: 'Scandinavian' },
  { value: 'South American', label: 'South American' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Syrian', label: 'Syrian' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Vietnamese', label: 'Vietnamese' },
]

export default cuisinesList
